import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import Modal from 'styled-react-modal';
import { SpecialModalBackground } from '../../../components/Commons';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { IGetMyHealthCoachFormsListInput, IGetMyHealthCoachFormsListOutput, IHealthCoachFMyHealthCoachFormsListOutputFrm, IHealthCoachFMyHealthCoachFormsListOutputTarget } from '../../../graphql/types/queries/forms';
import { GET_MY_FORMS_LIST } from '../../../graphql/queries';
import PleaseWait from '../../../components/PleaseWait';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const Itm = styled(Flex)`
  flex-direction: column;
  background: white;
  color: rgb(52, 79, 122);
  transition: all 0.3s ease;
  padding: 12px 20px;
  border-radius: 12px;
  border: 1px solid rgb(52, 79, 122);
  cursor: pointer;
  &:hover {
    color: white;
    background: rgb(52, 79, 122);
  }
`

interface IPickNewNoteProps {
  onCancel: () => void,
  onSelected: (e: IHealthCoachFMyHealthCoachFormsListOutputFrm) => void
}

export const PickNewNote: React.FC<IPickNewNoteProps> = ({ onCancel, onSelected }) => {
  const navigate = useNavigate()
  const [targets, setTargets] = useState<Array<IHealthCoachFMyHealthCoachFormsListOutputTarget>>()
  const [selectedTarget, setSelectedTarget] = useState<IHealthCoachFMyHealthCoachFormsListOutputTarget>()
  const { data, loading, error, refetch } = useQuery<IGetMyHealthCoachFormsListOutput, IGetMyHealthCoachFormsListInput>(GET_MY_FORMS_LIST, {
    onCompleted: (e) => {
      if (!e || !e.getMyHealthCoachFormsList) return
      const t = []
      for (let index = 0; index < e.getMyHealthCoachFormsList.length; index++) {
        const element = e.getMyHealthCoachFormsList[index];
        t.push(element.target)
      }

      setTargets(t)
      setSelectedTarget(t[0])
    }
  })

  return (
    <Modal
      isOpen={true}
      onBackgroundClick={() => {
        onCancel();
      }}
      onEscapeKeydown={() => {
        onCancel();
      }}
    >
      <SpecialModalBackground
        onClick={() => {
          onCancel();
        }}
      >
        <Box
          style={{
            margin: '0 auto',
            alignSelf: 'center',
            borderRadius: '20px',
            position: 'relative',
            background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
            padding: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            maxWidth: '95vw',
            minWidth: 'initial',
            maxHeight: '95vh',
            minHeight: '95vh',
            overflowY: 'hidden',
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
            {!!loading ? (
              <PleaseWait />
            ) : (
              <Flex flexDirection={'column'}>
                <Flex mb={4}>
                  {targets?.map(target => {
                    return (
                      <Flex onClick={() => {
                        setSelectedTarget(target)
                      }} style={{ cursor: 'pointer', borderRadius: '20px', border: '1px solid #344F7A', padding: '4px 12px', backgroundColor: selectedTarget && selectedTarget.id === target.id ? '#344F7A' : 'white' }}>
                        <Text style={{ color: selectedTarget && selectedTarget.id === target.id ? 'white' : '#344F7A' }}>{target.target}</Text>
                      </Flex>
                    )
                  })}
                </Flex>
                {(data?.getMyHealthCoachFormsList?.find(x => x.target.id === selectedTarget?.id)?.mine.filter(x => {
                  return x.isActive && !x.isDeleted
                }) || []).length < 1 ? (
                  <Flex flexDirection={'column'}>
                    <Text>You haven't defined any form for your library.</Text>
                    <Text onClick={() => {
                      navigate('/form-listing')
                    }}>Please select them <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>here</span></Text>
                  </Flex>
                ) : (
                  <>
                    {data?.getMyHealthCoachFormsList?.find(x => x.target.id === selectedTarget?.id)?.mine.filter(x => {
                      return x.isActive && !x.isDeleted
                    }).sort((a, b) => {
                      if (a.isFavorite && !b.isFavorite) return -1
                      return 0
                    }).map(mine => {
                      return (
                        <Itm mb={2} flex={1} width='100%' onClick={()=>onSelected(mine)}>
                          <Flex alignItems={'center'}>
                            {mine.isFavorite && (
                              <i className="fa-solid fa-star" style={{ marginRight: '12px', color: '#cece00' }}></i>
                            )}
                            <Text fontWeight={600}>{mine.name}</Text>
                          </Flex>
                          {mine.description && (
                            <Text mt={2}>{mine.description}</Text>
                          )}
                          <Text mt={3} fontWeight={300} fontSize={'12px'} fontStyle={'italic'}>created by {mine.createdBy.firstName} - last update {moment(mine.updatedAt).format('MM-DD-YYYY hh:mmA')}</Text>
                        </Itm>
                      )
                    })}
                  </>
                )}
              </Flex>
            )}
          </Wrapper>
        </Box>
      </SpecialModalBackground>
    </Modal>);
}